import { useState } from 'react';
import { getEntitlements } from '@surfline/web-common';
import reportErrorToNewRelic from 'utils/reportErrorToNewRelic';
import getUserType from 'utils/getUserType';
import { useMount } from 'react-use';
import { useAppSelector } from 'stores/hooks';
import { useUserDetails } from 'selectors/user';
import { getConditionsBasedAdUnits } from 'selectors/spot';
import { addToBlogheradsQueue, getBlogherads } from 'utils/blogherads';

const useSheMediaAdVastTag = (hasAdFreeCamPermissions: boolean, camId?: string, enabled = true) => {
  const [adVastUrl, setAdVastUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const entitlements = useAppSelector(getEntitlements);
  const conditionsBasedAdUnits = useAppSelector(getConditionsBasedAdUnits);
  const userDetails = useUserDetails();
  const isRegisteredUser = !!userDetails?._id;

  useMount(() => {
    if (!enabled) return;
    if (!hasAdFreeCamPermissions) {
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
      }, 10000);

      const blogherads = getBlogherads();
      if (!blogherads.adq) {
        setIsLoading(false);
        return;
      }

      addToBlogheradsQueue(() => {
        try {
          const blogherads = getBlogherads();
          if (!blogherads.getVastTag || !blogherads.setConf) {
            setIsLoading(false);
            return;
          }
          const userType = getUserType(entitlements, isRegisteredUser);
          blogherads.setConf('vertical', 'Video_Companion');
          if (camId) {
            blogherads.setTargeting('pub_meta_1', camId);
          }
          if (userType) {
            blogherads.setTargeting('pub_meta_6', userType);
          }
          if (conditionsBasedAdUnits) {
            if (conditionsBasedAdUnits.pub_meta_2) {
              blogherads.setTargeting('pub_meta_2', conditionsBasedAdUnits.pub_meta_2);
            }
            if (conditionsBasedAdUnits.pub_meta_3) {
              blogherads.setTargeting('pub_meta_3', conditionsBasedAdUnits.pub_meta_3);
            }
            if (conditionsBasedAdUnits.pub_meta_5) {
              blogherads.setTargeting('pub_meta_5', conditionsBasedAdUnits.pub_meta_5);
            }
            if (conditionsBasedAdUnits.pub_meta_8) {
              blogherads.setTargeting('pub_meta_8', conditionsBasedAdUnits.pub_meta_8);
            }
            if (conditionsBasedAdUnits.pub_meta_9) {
              blogherads.setTargeting('pub_meta_9', conditionsBasedAdUnits.pub_meta_9);
            }
          }
          blogherads.getVastTag((tag: string) => {
            setIsLoading(false);
            setAdVastUrl(tag);
          });
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
          reportErrorToNewRelic(error, 'useSheMediaAdVastTag', {});
          setIsLoading(false);
        }
      });
    }
  });

  return {
    adVastUrl,
    adTagLoading: isLoading,
  };
};

export default useSheMediaAdVastTag;
